// @flow
import { InstanceOpinometroActionTypes } from './constants';

type InstanceOpinometroAction = { type: string, payload: {} | string };

// common success
export const instanceOpinometroApiResponseSuccess = (actionType: string, data: any): InstanceOpinometroAction => ({
    type: InstanceOpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const instanceOpinometroApiResponseError = (actionType: string, error: string): InstanceOpinometroAction => ({
    type: InstanceOpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getInstanceOpinometro = (id: string): InstanceOpinometroAction => ({
    type: InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO,
    payload: { id },
});

export const addInstanceOpinometro = (instanceOpinometro:any):InstanceOpinometroAction=>({
    type:InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO,
    payload:instanceOpinometro
})
export const updateInstanceOpinometro = (instanceOpinometro:any):InstanceOpinometroAction=>({
    type:InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO,
    payload:instanceOpinometro
})
export const deleteInstanceOpinometro = (id:string):InstanceOpinometroAction=>({
    type:InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO,
    payload:{id}
})

export const listInstanceOpinometro = (params:any): InstanceOpinometroAction => ({
    type: InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS,
    payload: params,
});

export const resetInstanceOpinometro = (): InstanceOpinometroAction => ({
    type: InstanceOpinometroActionTypes.RESET,
    payload: {},
});

